import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEMONE
import BaseMixer from "@/router/views/BaseMixer";
import simplebar from "simplebar-vue";
import Loader from "@/components/widgets/loader.vue";
import { Guid } from "guid-typescript";
import workflowMachine from "../machines/workflowMachine";
import { interpret } from "xstate";
import WorkFlowStepConfigurationComponent from "./WorkFlowStepConfigurationComponent.vue";
import { Container, Draggable } from "vue-smooth-dnd";
import { applyDrag } from "@/utilities/ApplyDrag";
import WorkFlowStepComponent from "./WorkFlowStepComponent.vue";
import WorkFlowEditTitleComponent from "./WorkFlowEditTitleComponent.vue";
import { PAWorkFlowStepsModel } from "@/store/models/paWorkFlow/paWorkFlowStepsDTO";
import { PAWorkFlowModel } from "@/store/models/paWorkFlow/paWorkFlowDTO";
import _ from "lodash";
import { format } from "date-fns";
import { toaster } from "@/utilities/toaster";
import { PAWorkFlowModule } from "@/store/modules/paWorkFlow.module";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import { Constant } from "@/store/constant";
import { v4 as uuidv4 } from "uuid";
let WorkflowComponent = /** @class */ (() => {
    let WorkflowComponent = class WorkflowComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.workflowSteps = [];
            this.steps = [];
            this.stepConfigPopupTopPosition = 0;
            this.mode = "";
            this.workflowStepConfig = new PAWorkFlowStepsModel();
            this.workFlowModel = new PAWorkFlowModel();
            this.machine = workflowMachine.withContext({
                mode: "",
                workFlowId: Guid.createEmpty(),
            });
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.previousState = this.machine.initialState;
            this.dropPlaceholderOptions = {
                className: "drop-preview",
                animationDuration: "150",
                showOnTop: false,
            };
        }
        send(event) {
            this.machineService.send(event);
        }
        showModal(mode, workflowId) {
            if (mode == "Add") {
                this.workFlowModel = new PAWorkFlowModel();
            }
            this.$bvModal.show("workflow-modal");
            this.mode = mode;
            this.machineService.send({ type: "SHOW_WORKFLOW", mode: mode, workFlowId: workflowId });
        }
        closeWorkflow() {
            this.$bvModal.hide("workflow-modal");
            this.machineService.send({ type: "CANCEL_WORKFLOW" });
            this.emptyworkflowObjects();
        }
        emptyworkflowObjects() {
            this.workflowSteps = [];
        }
        emptyObject() {
            for (const prop in this.workFlowModel) {
                if (this.workFlowModel.hasOwnProperty(prop)) {
                    this.workFlowModel[prop] = PAWorkFlowModel.prototype[prop];
                }
            }
        }
        showWorkflowTitle() {
            this.machineService.send({ type: "EDIT_WORKFLOW_TITLE" });
        }
        onDropStep(collection, dropResult) {
            if (dropResult.removedIndex !== null && dropResult.addedIndex !== null) {
                return "";
            }
            if (this.state.matches("manageStepConfiguration")) {
                return "";
            }
            if (dropResult.addedIndex != null) {
                var existingStep = this.availableSteps.find((step) => step.paStepId == dropResult.payload.paStepId);
                if (existingStep) {
                    dropResult.payload.paReviewFormId = null;
                    dropResult.payload.stepDuration = existingStep.stepDuration;
                    const index = this.steps.findIndex((step) => step.stepOrder > existingStep.stepOrder);
                    if (index != -1) {
                        dropResult.addedIndex = index;
                    }
                    else {
                        dropResult.addedIndex = this.steps.length + 1;
                    }
                }
            }
            this[collection] = applyDrag(this[collection], dropResult);
        }
        onDropWorkFlowSteps(collection, dropResult) {
            if (this.state.matches("manageStepConfiguration")) {
                return "";
            }
            if (dropResult.addedIndex !== null && dropResult.removedIndex == null) {
                if (this.handleClientAssignment(collection, dropResult)) {
                    this.onDropStep("steps", dropResult);
                    toaster.ShowError("A Client Interfacer Step is already exists in the Workflow.");
                    return "";
                }
                if (this.handleReportingTargetAudience(collection, dropResult)) {
                    this.onDropStep("steps", dropResult);
                    toaster.ShowError("A ReportingTo Step is already exists in the Workflow.");
                    return "";
                }
                // It is an temporary Fix, as we are facing issue in cycle creation if the first step of the workflow is reporting to.
                // if (this.reportingToStepCannotBeFirstStep(collection, dropResult)) {
                //     this.onDropStep("steps", dropResult);
                //     toaster.ShowError("A ReportingTo Step is cannot be at first step");
                //     return "";
                // }
                if (this.handleClient(collection, dropResult)) {
                    toaster.ShowError("A Client Step is already exists in the Workflow.");
                    this.onDropStep("steps", dropResult);
                    return "";
                }
                this[collection] = applyDrag(this[collection], dropResult);
            }
            if (dropResult.removedIndex !== null && dropResult.addedIndex !== null) {
                const updatedCollection = [...this[collection]];
                this[collection] = applyDrag(updatedCollection, dropResult);
            }
            if (dropResult.removedIndex !== null && dropResult.addedIndex == null) {
                this[collection] = applyDrag(this[collection], dropResult);
            }
        }
        handleClientAssignment(collection, dropResult) {
            const clientInterfacer = this[collection].some((step) => step.clientAssignmentApplicable);
            return clientInterfacer && dropResult.payload.clientAssignmentApplicable === true;
        }
        // public reportingToStepCannotBeFirstStep(collection, dropResult) {
        //     if (dropResult.addedIndex == 0 && dropResult.payload.paStepTargetAudienceId === this.targetAudience.ReportingTo()) {
        //         return true;
        //     }
        // }
        handleReportingTargetAudience(collection, dropResult) {
            const retportingCount = this[collection].filter((step) => step.paStepTargetAudienceId === this.targetAudience.ReportingTo()).length;
            if (retportingCount === 1 && dropResult.payload.paStepTargetAudienceId === this.targetAudience.ReportingTo()) {
                return true;
            }
        }
        handleClient(collection, dropResult) {
            const clientCount = this[collection].filter((step) => step.paStepTargetAudienceId === this.targetAudience.Client()).length;
            if (clientCount === 1 && dropResult.payload.paStepTargetAudienceId === this.targetAudience.Client()) {
                return true;
            }
        }
        getStepsPayload(index) {
            if (this.state.matches("manageStepConfiguration")) {
                return "";
            }
            return this.steps[index];
        }
        getWorkFlowStepsPayload(index) {
            if (this.state.matches("manageStepConfiguration")) {
                return "";
            }
            return this.workflowSteps[index];
        }
        showStepConfig(item, index) {
            this.workflowStepConfig = item;
            this.machineService.send({ type: "MANAGE_STEP_CONFIG" });
            this.stepConfigPopupTopPosition = index * 64 + "px !important";
        }
        closeStepConfig() {
            this.machineService.send({ type: "CANCEL_STEP_CONFIG" });
        }
        updateWorkflowStepConfig(updatedConfig) {
            const indexToUpdate = this.workflowSteps.findIndex((step) => step.paStepId === updatedConfig.paStepId && step.stepOrder === updatedConfig.stepOrder);
            if (indexToUpdate !== -1) {
                this.workflowSteps[indexToUpdate] = updatedConfig;
            }
            else {
                this.workflowSteps.push(updatedConfig);
            }
            this.machineService.send({ type: "SET_STEP_CONFIG" });
        }
        updateWorkFlowName(name) {
            this.workFlowModel.name = name;
            this.machineService.send({ type: "SAVE_WORKFLOW_TITLE" });
        }
        closeWorkflowTitle() {
            this.machineService.send({ type: "CANCEL_WORKFLOW_TITLE" });
        }
        checkClientParticipations() {
            var clientStepExist = this.workflowSteps.find((step) => step.paStepTargetAudienceId.toString() == this.targetAudience.Client());
            if (clientStepExist) {
                if (clientStepExist.stepOrder != this.workflowSteps.length) {
                    toaster.ShowError("The workflow cannot be saved unless the final step is designated as the Client Step.");
                    return false;
                }
                var isClientInterfacer = this.workflowSteps.find((step) => step.clientAssignmentApplicable);
                if (!isClientInterfacer) {
                    toaster.ShowError("Please provide a Client Interfacer Step before Client Step while creating Workflows.");
                    return false;
                }
                if (isClientInterfacer.stepOrder != this.workflowSteps.length - 1) {
                    toaster.ShowError("The workflow cannot be saved unless a 'Client Interfacer' step is present before the 'Client' step in the workflow sequence.");
                    return false;
                }
            }
            else {
                var isClientInterfacer = this.workflowSteps.find((step) => step.clientAssignmentApplicable);
                if (isClientInterfacer) {
                    if (isClientInterfacer.stepOrder != this.workflowSteps.length) {
                        toaster.ShowError("The workflow cannot be saved unless the final step is designated as the Client Interfacer Step.");
                        return false;
                    }
                }
            }
            return true;
        }
        saveWorkFlow() {
            if (this.workflowSteps.length < 1) {
                toaster.ShowError("Workflow must have more than one step.");
            }
            this.workflowSteps.forEach((step, index) => {
                step.stepOrder = index + 1;
            });
            if (!this.workflowSteps.some((step) => step.paReviewFormId !== null)) {
                toaster.ShowError("WorkFlow should have at least one Step configured with a form.");
            }
            else {
                var isClientStep = this.checkClientParticipations();
                if (isClientStep) {
                    this.workFlowModel.workFlowSteps = this.workflowSteps;
                    if (this.mode == "Add" || this.mode == "Clone") {
                        this.machineService.send({ type: "SAVE_WORKFLOW", item: this.workFlowModel });
                    }
                    else {
                        this.machineService.send({ type: "EDIT_WORKFLOW", item: this.workFlowModel });
                    }
                }
            }
        }
        setWorkFlowDetails() {
            this.workFlowModel.name = "Untitled Workflow";
            this.steps = this.availableSteps;
        }
        refreshPage() {
            this.$emit("refreshPage");
        }
        setWorkFlow() {
            if (this.mode == "Clone") {
                this.setClonedWorkFlow();
            }
            else {
                this.workFlowModel = this.workflow;
                this.workflowSteps = this.workflow.workFlowSteps;
            }
            this.steps = this.availableSteps.filter((step) => {
                return !this.workflowSteps.some((workflowStep) => {
                    return step.paStepId === workflowStep.paStepId;
                });
            });
        }
        // A copy of the loaded workflow with new Ids, so saving it creates a new workflow and leaves the source untouched.
        setClonedWorkFlow() {
            const clone = _.cloneDeep(this.workflow);
            clone.id = uuidv4();
            clone.isArchived = false;
            clone.name = PAWorkFlowModule.cloneWorkFlowName || `Copy of ${clone.name}`.substring(0, 500);
            clone.workFlowSteps.forEach((step) => {
                step.id = uuidv4();
                step.paWorkflowId = clone.id;
                // Forms archived since the source was built aren't selectable any more.
                if (step.paReviewFormId && !this.forms.some((form) => form.id === step.paReviewFormId)) {
                    step.paReviewFormId = null;
                    step.paReviewFormName = null;
                }
            });
            this.workFlowModel = clone;
            this.workflowSteps = clone.workFlowSteps;
        }
        get targetAudience() {
            return Constant.TargetAudiences;
        }
        get formattedCurrentTime() {
            const currentTime = new Date();
            const formattedTime = format(currentTime, "MMM dd, yyyy, hh:mma");
            return formattedTime;
        }
        get availableSteps() {
            return _.orderBy(PAWorkFlowModule.steps, ["stepOrder"], ["asc"]);
        }
        get forms() {
            return _.sortBy(PAWorkFlowModule.forms, ["value"], ["asc"]);
        }
        get workflow() {
            return PAWorkFlowModule.workFlow;
        }
        get createdOn() {
            return PAWorkFlowModule.createdOnAsString;
        }
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                this.previousState = this.state;
                this.state = state;
                this.previousState;
                if (this.previousState.matches("gettingDetailsForWorkflows") && this.state.matches("loadedWorkflows")) {
                    this.setWorkFlowDetails();
                }
                if (this.previousState.matches("gettingWorkflows") && this.state.matches("loadedWorkflows")) {
                    this.setWorkFlow();
                }
                if (this.previousState.matches("savingWorkflow") && this.state.matches("modalDormant")) {
                    this.refreshPage();
                    this.closeWorkflow();
                    this.emptyObject();
                }
                if (this.previousState.matches("updatingWorkflow") && this.state.matches("modalDormant")) {
                    this.closeWorkflow();
                    this.emptyObject();
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    WorkflowComponent = __decorate([
        Component({
            name: "WorkflowComponent",
            components: {
                simplebar,
                Loader,
                Container,
                Draggable,
                WorkFlowStepConfigurationComponent,
                WorkFlowStepComponent,
                WorkFlowEditTitleComponent,
                SectionLoader,
            },
        })
    ], WorkflowComponent);
    return WorkflowComponent;
})();
export default WorkflowComponent;
